
type CurrencyType = 'EUR' | 'USD'
const currencySymbols: Record<CurrencyType, string> = {
  EUR: '€',
  USD: '$'
}

const priceFormatter = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatPrice = (price: number, currency: CurrencyType) => {
  //returns 1,- $ or 1,10 $
  if(Number.isInteger(price)){
    const formattedInt = new Intl.NumberFormat('de-DE').format(price);
    return `${formattedInt},- ${currencySymbols[currency]}`;
//    return `${price},- ${currencySymbols[currency]}`;
  }

  return `${priceFormatter.format(price)} ${currencySymbols[currency]}`;
//  return `${price.toFixed(2)} ${currencySymbols[currency]}`
}
